<template>
  <div class="project-class">
    <SimpleTable
      :show-index="false"
      ref="ProjectClassTable1"
      table-code="ProjectClassTable1"
      :columns="columns1"
      :data="tableData1"
      :loading="loading1"
      @row-select="handleRowSelect1"
    />
    <SimpleTable
      :show-index="false"
      ref="ProjectClassTable2"
      table-code="ProjectClassTable2"
      :columns="columns2"
      :data="tableData2"
      :loading="loading2"
    />
    <SimpleTable
      :show-index="false"
      ref="ProjectClassTable3"
      table-code="ProjectClassTable3"
      :columns="columns3"
      :data="tableData3"
      :loading="loading3"
      @row-select="handleRowSelect3"
    />
    <SimpleTable
      :show-index="false"
      ref="ProjectClassTable4"
      table-code="ProjectClassTable4"
      :columns="columns4"
      :data="tableData4"
      :loading="loading4"
    />
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords } from '@/utils/index'
export default {
  name: 'ProjectClass',
  components: {
    SimpleTable
  },
  data() {
    return {
      columns1: [{ field: 'name', title: '工程分类', tree: true }],
      columns2: [{ field: 'name', title: '工程参数' }],
      columns3: [{ field: 'name', title: '工程特征' }],
      columns4: [{ field: 'name', title: '特征值' }],

      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],

      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      this.getTable1()
    },
    async getTable1() {
      this.tableData1 = []
      this.loading1 = true
      const res = await this.$service.get(
        'engineering-classify/listAllClassify',
        {}
      )
      this.loading1 = false
      this.tableData1 = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs.ProjectClassTable1.initialized()
    },
    async getTable2(row = {}) {
      this.tableData2 = []
      this.loading2 = true
      const res = await this.$service.get('/engineering-classify/params', {
        classifyId: row.id
      })
      this.loading2 = false
      this.tableData2 = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs.ProjectClassTable2.initialized()
    },
    async getTable3(row = {}) {
      this.tableData3 = []
      this.loading3 = true
      const res = await this.$service.get('/engineering-classify/features', {
        classifyId: row.id
      })
      this.loading3 = false
      this.tableData3 = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs.ProjectClassTable3.initialized()
    },
    async getTable4(row = {}) {
      this.tableData4 = []
      this.loading4 = true
      const res = await this.$service.get(
        '/engineering-classify/feature-values',
        {
          featureId: row.id
        }
      )
      this.loading4 = false
      this.tableData4 = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs.ProjectClassTable4.initialized()
    },
    handleRowSelect1(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.tableData4 = []
      this.getTable2(obj)
      this.getTable3(obj)
    },
    // handleRowSelect2(rows) {
    //   const selectedRecord = rows[0]
    //   const obj = selectedRecord[0].originData
    //   this.getTable3(obj)
    // },
    handleRowSelect3(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.getTable4(obj)
    }
  }
}
</script>

<style scoped>
.project-class {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  column-gap: 12px;
}
</style>
